<template>
	<div v-if="effectiveFormId && logList.length" class="m-doc-log">
		<c-title>流程</c-title>

		<ul>
			<li v-for="(item, i) in logList" :key="i" class="flex">
				<template v-if="item.is_execute == 1">
					<div v-if="item.execute_state == 9" class="state flex-center" style="background: #f00;"><i class="tf">&#xe60f;</i></div>
					<div v-else class="state flex-center" style="background: #00BD3A;"><i class="tf">&#xe63f;</i></div>
				</template>
				<div v-else-if="item == activeFlow" class="state flex-center" style="background: #FF6900;"><i class="tf">&#xe60c;</i></div>
				<member-icon :icon="item.head_photo" :name="item.executor_realname[0]"></member-icon>
				<div class="flex-grow">
					<div class="flex">
						<div class="flex-grow">
							<span class="desc">{{item.node_name}}</span>
							<p class="name">{{item.executor_realname.join('、')}}</p>
						</div>
						<div v-if="item.execute_date" class="date">{{item.execute_date}}</div>
					</div>
					<div v-if="item.execute_state == 9" class="remark">
						<p>驳回原因：{{item.remark}}</p>
					</div>
				</div>
			</li>
		</ul>

		<dl v-if="carbonList.length">
			<dt>抄送给({{carbonList.length}})</dt>
			<dd class="flex-wrap">
				<member-icon v-for="(person, i) in carbonList" :key="i" :icon="person.head_photo" :name="person.user_realname" text></member-icon>
			</dd>
		</dl>
	</div>
</template>

<script>
	export default {
		name: 'docLog',

		props: {
			formId: [String, Number]
		},

		data() {
			return {
				activeFlow: null,
				logList: [],
				carbonList: [],
				localFormId: ''
			}
		},

		computed: {
			effectiveFormId() {
				return this.localFormId || this.formId;
			}
		},

		watch: {
			formId() {
				this.update();
			}
		},

		methods: {
			init(formId) {
				this.localFormId = formId;
				this.update();
			},
			update() {
				let formId = this.effectiveFormId;
				if (!formId) {
					this.logList = [];
					this.carbonList = [];
					return;
				}
				this.request({
					url: '/flow/workflow/approval/info',
					data: {
						form_id: formId
					},
					success: data => {
						let list = [];
						while (data.log_list[0]) {
							let nodeId = data.log_list[0].node_id;
							let next = data.log_list.findIndex(item => item.node_id != nodeId);
							let group = data.log_list.splice(
								0,
								Math.min(
									data.log_list.filter(item => item.node_id == nodeId).length,
									Math.max(1, next == -1 ? data.log_list.length : next)
								)
							);
							// 组内元信息优先取已执行审批的那条，其次是第一条
							list.push(Object.assign({}, group.find(item => item.is_execute == 1) || group[0], {
								executor_realname: group.map(item => item.executor_realname)
							}));
						}
						this.logList = list;
						this.carbonList = data.copy_to_list;
						this.activeFlow = this.logList.find(item => item.is_execute == 0);
						let $base = this.$parent.$children.find(item => item.$options.name == 'docBase');
						if ($base && this.activeFlow) {
							$base.approver = this.activeFlow.executor_realname.join('、');
						}
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-doc-log {
		border-top: 10px solid #F2F2F6;
		padding: 10px 24px 20px;

		ul {
			padding: 10px 0;

			li {
				gap: 12px;
				position: relative;

				&:nth-last-child(n+2) {
					min-height: 75px;

					&:before {
						content: '';
						position: absolute;
						left: 18px;
						top: 42px;
						bottom: 4px;
						width: 2px;
						background: #ccc;
					}
				}

				.state {
					z-index: 1;
					position: absolute;
					left: 26px;
					top: 26px;
					width: 14px;
					height: 14px;
					border: 3px solid #fff;
					border-radius: 50%;
					font-size: 10px;
					color: #fff;
				}

				.desc {
					display: block;
					margin: 4px 0 6px;
					font-size: 13px;
					color: #999;
				}

				.name {
					margin-top: 8px;
					font-size: 15px;
				}

				.date {
					font-size: 12px;
					color: #bbb;
				}

				.remark {
					border-radius: 4px;
					padding: 10px 12px;
					margin-top: 10px;
					line-height: 20px;
					font-size: 13px;
					color: #666;
					background: #F9F9F9;
				}
			}
		}

		dl {
			dt {
				line-height: 40px;
				font-size: 15px;
				color: #999;
			}

			dd {
				gap: 6px;
			}
		}
	}
</style>
